import clsx from 'clsx';
import styles from './TrustPilotStars.module.scss';
import { StarSize, TrustPilotStarsProps } from '../TrustPilot.types.ts';

const TrustPilotStar = ({
  size = 'sm',
  parts,
}: {
  size?: StarSize;
  parts?: number;
}) => (
  <div
    className={clsx(
      size && styles[`size--${size}`],
      !!parts && styles[`partialStar-${parts}`],
      styles.star
    )}
    data-size={size}
  >
    <svg aria-label="trustpilot star" viewBox="0 0 46 46">
      <path d="M0 46.330002h46.375586V0H0z" fill="#00b67a" />
      <path
        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
        fill="#fff"
      />
    </svg>
  </div>
);

export const TrustPilotStars = ({ rating, size }: TrustPilotStarsProps) => {
  const [count, decimal] = rating.toString().split('.');
  const starsCount = parseInt(count);
  const parts = parseInt(decimal);

  const Star = () => (
    <div className={styles.starWrapper}>
      <TrustPilotStar size={size} />
    </div>
  );

  const PartialStar = () => (
    <div className={clsx(styles.starWrapper, styles.partial)}>
      <TrustPilotStar size={size} parts={parts} />
    </div>
  );

  return (
    <div className={styles.container} data-size={size}>
      {Array(starsCount)
        .fill('')
        .map((_, key) => (
          <Star key={'TrustPilot_star' + key} />
        ))}
      {!!parts && <PartialStar />}
    </div>
  );
};
